"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.domains = void 0;
exports.domains = ["terms"];
